import PropTypes from "prop-types"
import { Avatar, ListItemAvatar, ListItem, ListItemText, Button } from "@mui/material"
import { Work } from "@mui/icons-material"
import { appendTimestamp } from "modules/server-notifications/helpers"
import withNavigate from "hocs/withNavigate"

function Success({ navigate, message, targetName, action, createdAt }) {
  const secondaryAction = action ? <Button color="primary" onClick={() => action.fn(navigate)}>
    {action.text}
  </Button> : null

  return <ListItem className="success" secondaryAction={secondaryAction}>
    <ListItemAvatar>
      <Avatar>
        <Work />
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary={message} secondary={appendTimestamp(targetName, createdAt)} />
  </ListItem>
}

Success.propTypes = {
  navigate: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  targetName: PropTypes.string.isRequired,
  action: PropTypes.object,
  createdAt: PropTypes.string.isRequired,
}

export default withNavigate(Success)
